import Image from 'next/image';
import { StyledLiveTaskCard } from './LiveTaskCard.styled';

export default function LiveTaskCard({
  name,
  englishName,
  thumb,
  selected,
  onClick,
}) {
  return (
    <StyledLiveTaskCard onClick={onClick} selected={selected}>
      <div className="task-thumb">
        <Image src={thumb} layout={'fill'} alt={name} />
      </div>
      <div className="task-info">
        <span className="task-title">{name}</span>
        <div className="task-subtitle">
          <span>{englishName}</span>
        </div>
      </div>
    </StyledLiveTaskCard>
  );
}
